import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { deleteCategory } from "../api";

type CustomError = {
  response?: {
    data?: {
      message?: string;
      status?: string;
    };
  };
};
export const useDeleteCategory = () => {
  const router = useNavigate();
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: deleteCategory,
    onSuccess() {
      queryClient.refetchQueries({ queryKey: ["CATEGORY"] });
      router("/category");
      toast.success("Success Delete Category");
    },

    onError(error: unknown) {
      console.log(error);
      const err = error as CustomError;
      const message = err?.response?.data?.message
        ? `Status: ${err.response.data.status} - ${err.response.data.message}`
        : "Terjadi kesalahan pada database.";

      toast.error(message);
    },
  });

  return { Delete: mutate, isPending };
};
